exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Cover{\r\n    background-color: #e5eaf0;\r\n    overflow: hidden;\r\n    box-shadow: hsla(0, 0%, 0%, 0.16) 1px 11px 20px 0px;\r\n    position: fixed;\r\n    z-index: 1;\r\n    transition: all .4s ease-in-out;\r\n    max-height: 100vh;\r\n}\r\n\r\n.minified{\r\n    \r\n}\r\n\r\n@media all and (orientation:landscape) {\r\n    .Cover{\r\n        float: left;\r\n        width: 40vw;\r\n        height: 100vh;\r\n    }\r\n}\r\n\r\n@media all and (orientation:portrait) {\r\n    .minified{\r\n        max-height: 4vh;\r\n    }\r\n    \r\n}", ""]);

// exports
